import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { file_path } from "./environment";
import axios from "axios";

function Feedback({ item }) {
    return (
        <div className="feedback-item">
            <h4>{item.title}</h4>
            {item.content?.map((content, index) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: content }} />
            ))}
        </div>
    );
}

function Notable({ item }) {
    return (
        <div className="notable-item">
            <Link to={`/editorial/lawyers/${item.id}`} role="button">{item.name}</Link>
        </div>
    );
}

function getLatestYear(history) {
    const years = Object.keys(history || {}).sort((yearA, yearB) => Number(yearB) - Number(yearA));
    return years[0] || null;
}

function getSectionCount(subsections) {
    return Object.keys(subsections || {}).length;
}

function History({ history }) {
    if (!history) {
        return null;
    }

    return (
        <div className="firm-history-list">
            {Object.entries(history)
                .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
                .map(([year, data]) => (
                    <section key={year} className="firm-year-card">
                        <div className="firm-year-header">
                            <h3>{year}</h3>
                            <span>{data.ranking}</span>
                        </div>
                        <div className="firm-year-body">
                            {(data.feedback || [])
                                .filter((feedback) => feedback.title !== "Notable practitioners")
                                .map((feedback) => {
                                return <Feedback key={feedback.title} item={feedback} />;
                                })}
                        </div>

                        {data.notablePractitioners?.length ? (
                            <div className="firm-notables">
                                <h4>Notable practitioners</h4>
                                <div className="firm-notables-list">
                                    {data.notablePractitioners.map((lawyer) => {
                                        return <Notable key={`${year}-${lawyer.id}-${lawyer.name}`} item={lawyer} />;
                                    })}
                                </div>
                            </div>
                        ) : null}
                    </section>
                ))}
        </div>
    );
}

function Subsection({ subsection }) {
    const latestYear = getLatestYear(subsection.history);

    return (
        <section className="firm-section-card">
            <div className="firm-section-header">
                <div>
                    <p className="firm-section-kicker">{subsection.guide} Guide</p>
                    <h2>{subsection.practise}</h2>
                    <p className="firm-section-location">{subsection.location}</p>
                </div>
                <div className="firm-section-meta">
                    <div>
                        <span className="firm-meta-label">Years ranked</span>
                        <span className="firm-meta-value">{subsection.yearsRanked}</span>
                    </div>
                    {latestYear ? (
                        <div>
                            <span className="firm-meta-label">Latest year</span>
                            <span className="firm-meta-value">{latestYear}</span>
                        </div>
                    ) : null}
                </div>
            </div>
            <History history={subsection.history} />
        </section>
    );
}

function Content({ subsections }) {
    if (!subsections) {
        return null;
    }

    return (
        <div className="firm-sections">
            {Object.entries(subsections).map(([id, subsection]) => (
                <Subsection key={id} subsection={subsection} />
            ))}
        </div>
    );
}

export default function EditorialFirms() {
    const [firm, setFirm] = useState({});
    const { firmId } = useParams();

    useEffect(() => {
        axios.get(file_path(`/firm-page/${firmId}.json`)).then((res) => {
            setFirm(res.data);
            document.title = `${res.data.name}`;
        });
    }, [firmId]);

    const sectionCount = getSectionCount(firm.subsections);

    return (
        <main className="firm-editorial-page">
            <section className="hero firm-hero">
                <h1>{firm.name}</h1>
                <div className="firm-hero__stats">
                    <div className="firm-hero__stat">
                        <span className="firm-meta-label">Practice areas</span>
                        <span className="firm-meta-value">{sectionCount}</span>
                    </div>
                </div>
            </section>
            <Content subsections={firm.subsections} />
        </main>
    );
}